/**
 * ShareResposive
 * 
 * @Author: Focci
 * @Date: 2023-10-11 12:23:45
 * @Last Modified by: Focci
 * @Last Modified time: 2023-10-11 12:23:45
 */

import PropTypes from 'prop-types'
import { ButtonBase } from '@comp/material'
import { useCallback } from 'react'
import { ShareTrigger } from './ShareDropdown'

export default function ShareResposive({
  trigger = <ShareTrigger />,
  buttonClassName,
  shareData,
  onBeforeShare = () => {}
}) {
  const handleClick = useCallback(() => {
    onBeforeShare()
    window.navigator.share(shareData)
  }, [shareData, onBeforeShare])
  
  return (
    <ButtonBase 
      className={buttonClassName}
      onClick={handleClick}
    >
      {trigger}
    </ButtonBase>
  )
}

ShareResposive.propTypes = {
  trigger: PropTypes.node,
  buttonClassName: PropTypes.string,
  shareData: PropTypes.object,
}
